export default "__VITE_ASSET__fcf8626f__"